import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';
import { HttpModule} from '@angular/http';
import { Camera } from '@ionic-native/camera';
import { Geolocation } from '@ionic-native/geolocation';
import {LOGIN_INDEX} from '../pages/login/index';
import {TABS_INDEX} from '../pages/tabs/index';
import {TEST_INDEX} from '../pages/test/index';
import {HOME_INDEX} from '../pages/home/index';
import { APPLICATION_INDEX } from '../pages/application/index'
import {ABOUT_INDEX} from'../pages/about/index';
import {MESSAGE_INDEX} from'../pages/message/index';
import {COMM_INDEX} from '../pages/comm/index';
import {SERVCICETS} from '../providers/service';
import  {SERVCICEEX} from '../providers/service';
import {TRIP_EX} from '../pages/trip/trip_ec';
import { AppState } from './app.global';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { DynamicFormModule } from '../pages/dynamic/dynamic-form.module';
import { ErrorPage } from '../pages/error/error';
import {TRIP_SERVICE} from '../pages/trip/trip_ec';
import {SERVICE_INDEX} from '../pages/service/index'
import {COMMON_SERARCH_INDEX} from '../pages/commonsearch/index';
import { KeywordsPipe } from '../pipes/keywords/keywords';
import { DateFormatePipe } from '../pipes/date-formate/date-formate';
import {DateFormatePipe2} from '../pipes/date-formate2/date-formate2';
import { DragulaService,DragulaModule } from 'ng2-dragula/ng2-dragula';
import {AppVersion} from '@ionic-native/app-version';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';
import { File } from '@ionic-native/file';
import {FileOpener} from '@ionic-native/file-opener';
import { ThemeableBrowser, ThemeableBrowserOptions, ThemeableBrowserObject } from '@ionic-native/themeable-browser';

@NgModule({
  declarations: [
    MyApp,
    ErrorPage,
    LOGIN_INDEX,
    TABS_INDEX,
    HOME_INDEX,
    ABOUT_INDEX,
    MESSAGE_INDEX,
    COMM_INDEX,
    SERVCICEEX,
    TEST_INDEX,
    TRIP_EX,
    APPLICATION_INDEX,
    SERVICE_INDEX,
    COMMON_SERARCH_INDEX,
    KeywordsPipe,
    DateFormatePipe2,
    DateFormatePipe
  ],
  imports: [
    HttpModule,
    BrowserModule,
    DynamicFormModule,
    DragulaModule,
    IonicModule.forRoot(MyApp,{
      backButtonText: '',// 配置返回按钮的文字
      iconMode: 'ios',//安卓icon强制使用ios的icon以及样式
      mode: 'ios',//样式强制使用ios样式
    })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    ErrorPage,
    LOGIN_INDEX,
    TABS_INDEX,
    HOME_INDEX,
    ABOUT_INDEX,
    MESSAGE_INDEX,
    COMM_INDEX,
    TEST_INDEX,
    TRIP_EX,
    APPLICATION_INDEX,
    SERVICE_INDEX,
    COMMON_SERARCH_INDEX
  ],
  providers: [
    ThemeableBrowser,
    StatusBar,
    DragulaService,
    AppState,
    Camera,
    Geolocation,
    SERVCICETS,
    TRIP_SERVICE,
    SplashScreen,
    AppVersion,
    InAppBrowser,
    FileTransfer, 
    FileTransferObject,
    File,
    FileOpener,
    {provide: ErrorHandler, useClass: IonicErrorHandler}
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts